import { useEffect, useRef } from 'react';

const brands = [
  { name: 'ECA', weight: 'font-black' },
  { name: 'Demirdöküm', weight: 'font-bold' },
  { name: 'Airfel', weight: 'font-bold' },
  { name: 'Daikin', weight: 'font-black' },
  { name: 'Ariston', weight: 'font-bold' },
  { name: 'Baymak', weight: 'font-bold' },
  { name: 'Vaillant', weight: 'font-bold' },
  { name: 'Sanica', weight: 'font-bold' },
  { name: 'Bosch', weight: 'font-black' },
  { name: 'Protherm', weight: 'font-bold' },
];

export default function BrandsSection() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('opacity-100', 'translate-y-0');
          e.target.classList.remove('opacity-0', 'translate-y-6');
        }
      }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll('.anim').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="brands" ref={ref} className="w-full py-12 md:py-16 bg-white border-y border-slate-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="anim opacity-0 translate-y-6 transition-all duration-500 text-center mb-10">
          <span className="inline-flex items-center gap-2 text-xs font-bold text-primary bg-[#f0f7ff] border border-[#dbeafe] px-3 py-1.5 rounded-full uppercase tracking-widest mb-3">
            Servis Verdiğimiz Markalar
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-2 tracking-tight">
            Tüm Marka Kombilere Servis
          </h2>
          <p className="text-sm text-slate-500 max-w-lg mx-auto">
            Türkiye&apos;nin önde gelen tüm kombi markalarına profesyonel teknik servis hizmeti sunuyoruz.
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {brands.map((brand, i) => (
            <div
              key={brand.name}
              className="anim opacity-0 translate-y-6 transition-all duration-500 w-[160px] md:w-[200px] h-[100px] md:h-[120px] flex items-center justify-center bg-white rounded-2xl border border-slate-100 hover:border-primary hover:shadow-sm cursor-pointer group px-4"
              style={{ transitionDelay: `${i * 50}ms` }}
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <span
                className={`text-base md:text-lg tracking-tight text-center leading-tight text-slate-400 group-hover:text-primary transition-all duration-150 ${brand.weight}`}
              >
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}